module.exports = __webpack_public_path__ + "fonts/3d8bd99.TTF";